import React from "react";
import "./SkeletonCard.css";

const SkeletonCard = () => {
  return (
    <div className="skeleton-card">
      <div className="skeleton-card-content">
        <div className="skeleton-image-wrapper">
          <div className="skeleton-image shimmer"></div>
        </div>
        <div className="skeleton-text-wrapper">
          <div className="skeleton-text shimmer"></div>
          <div className="skeleton-text shimmer"></div>
          <div className="skeleton-text shimmer"></div>
        </div>
      </div>
    </div>
  );
};

const SkeletonGrid = ({ count = 20 }) => {
  return (
    <div className="cards-container">
      <div className="inner-container">
        {Array.from({ length: count }).map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    </div>
  );
};

export { SkeletonCard, SkeletonGrid };
export default SkeletonGrid;

